import { faArrowsUpDownLeftRight, faArrowUpWideShort, faClock, faDatabase, faFile, faListCheck, faPlus, faQuoteLeft, faTag } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

import { useSelector } from 'react-redux';
import ButtonLight from '../../global/ButtonLight';
import axios from 'axios';
import ButtonAction from '../../global/ButtonAction';
import ButtonSquare from '../../global/ButtonSquare';
import ErrorAdd from '../../../util/ErrorAdd';

function WidgetAddFavorite({ id, idObject, addHandler, menuChangeHandler }) {
    /*
    allowedAdd - Разрешено добавление
    addHandler - Передает ID добавленного виджета. Для того чтобы перевести его в режим редактирования
    menuChangeHandler - Событие клика по основному меню(1-Добавление; 2-Редактирование)

    idObject:
            1	Задача
            2	Регулярная задача
            6   Регулярная задача. Трекер
            3	Доска
            4	Проект
            4	Пользователь
    */

    const stateWidget = useSelector((state) => state.widget);//Виджеты 
    const stateSize = useSelector((state) => state.size);//Размеры окна

    const [log, setLog] = useState(null);
    const [loadingId, setLoadingId] = useState(false);
    const [editing, setEditing] = useState(false);

    //Добавит виджет
    function widgetAdd(idWidget) {
        setLog(null);
        setLoadingId(idWidget);

        var name = null;

        if (idWidget === 4) {
            name = "Текст HTML";
        }
        if (idWidget === 5) {
            name = "Чек-лист";
        }
        if (idWidget === 6) {
            name = "Файлы";
        }
        if (idWidget === 7) {
            name = "Параметры";
        }

        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetAdd', { ID_Task: id, ID_Widget: idWidget })
                .then((res) => {
                    if (res.data.Status === 1) {
                        const number = res.data.Data;
                        addHandler({ idWidget: idWidget, number: number });
                        setLoadingId(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoadingId(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoadingId(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetAdd', { ID_TaskR: id, ID_Widget: idWidget })
                .then((res) => {
                    if (res.data.Status === 1) {
                        const number = res.data.Data;
                        addHandler({ idWidget: idWidget, number: number });
                        setLoadingId(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoadingId(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoadingId(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetAdd', { ID_Board_Task: id, ID_Widget: idWidget })
                .then((res) => {
                    if (res.data.Status === 1) {
                        const number = res.data.Data;
                        addHandler({ idWidget: idWidget, number: number });
                        setLoadingId(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoadingId(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoadingId(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }


    function wiggetIcon(id) {
        if (id === 1) {
            return faClock
        }
        if (id === 2) {
            return faArrowUpWideShort
        }
        if (id === 3) {
            return faTag
        }
        if (id === 4) {
            return faQuoteLeft
        }
        if (id === 5) {
            return faListCheck
        }
        if (id === 6) {
            return faFile
        }
        if (id === 7) {
            return faDatabase
        }
    }

    return (
        <>
            {stateSize.desktop === true ?
                (
                    <>
                        <div className="card-block-title">Widget</div>
                        <div key={editing} >
                            <div><ButtonAction typeBtn='widget' textBtn="Добавить Widget" onClick={() => menuChangeHandler(1)} /></div>
                            {editing === true ? (
                                <div className='mt-5'><ButtonAction border='border_dg' typeBtn='finish' textBtn="Завершить" onClick={() => { menuChangeHandler(2); setEditing(false) }} /></div>
                            ) : (

                                <div className='mt-5'><ButtonAction typeBtn='moving' textBtn="Редактировать стену" onClick={() => { menuChangeHandler(2); setEditing(true) }} /></div>
                            )}
                        </div>
                        <div className='row' style={{ paddingRight: '0px', paddingLeft: '0px' }}>
                            {stateWidget.list.filter(a => a.ID_Object === idObject & a.Favorite === true).map(item => (
                                <div key={item.ID} className='col-6'>
                                    <ButtonSquare text={item.Name} icon={wiggetIcon(item.ID)} onClick={() => widgetAdd(item.ID)} loading={loadingId === item.ID ? true : false} id={item.ID} />
                                </div>
                            ))}
                        </div>
                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    </>
                )
                :
                (
                    <div><ButtonAction typeBtn='widget' textBtn="Widget" onClick={() => menuChangeHandler(1)} /></div>
                )
            }
        </>
    );
}

export default WidgetAddFavorite;